/* eslint no-restricted-globals: ["off", "history"] */
import Component from '../../../scripts/utilities/component';

class EnglandSupportersPolls extends Component {
    componentDidMount() {
        this.answerOption = [...this.root.querySelectorAll('[data-ref="comp-option"]')];
        this.ctaButton = this.root.querySelector('[data-ref="cta-button"]');
        this.successContainter = this.root.querySelector('[data-ref="entry-success"]');
        this.errorContainter = this.root.querySelector('[data-ref="entry-error"]');
        this.APIURL = this.props.url;
        this.APIANSWERURL = this.props.answerurl;
        this.scConfig = window.engms.compMessage;
        this.signUpRedirect = this.root.querySelector('[data-ref="account-signup-redirect"]');
        this.competitionId = this.root.querySelector('[data-ref="competition-id"]').value;
        this.pollResultContainer = this.root.querySelector('[data-ref="poll-result-block"]');
        this.pollResultAnswers = this.root.querySelector('[data-ref="poll-result-block-answers"]');
        this.pollResultErrorContainter = this.root.querySelector('[data-ref="poll-result-error"]');
        window.onload = () => {
            this.getPollsResult();
        };

        this.bindEventListeners();

        // Check to see if there is a stored answer
        this.getLocalStorage();
        this.handleValidation();
    }

    bindEventListeners() {
        this.answerOption.forEach((option) => {
            option.addEventListener('click', this.handleValidation.bind(this));
        });
        this.ctaButton.addEventListener('click', this.handleAjaxCall.bind(this));
    }

    resetForm() {
        this.root.classList.remove('is--success');
        this.root.classList.remove('is--error');

        this.answerOption.forEach((option) => {
            const radioOption = option;
            radioOption.checked = false;
        });

        this.ctaButton.disabled = true;
    }

    handleValidation() {
        const answerInput = this.root.querySelector('input[data-ref="comp-option"]:checked');

        // Check answer selection for radio button
        if (answerInput) {
            this.selectAnswer = answerInput;
            this.ctaButton.disabled = false;
        }
        else {
            this.ctaButton.disabled = true;
        }
    }

    getPollsResult() {
        const httpRequest = new XMLHttpRequest();
        httpRequest.onreadystatechange = () => {
            if (httpRequest.readyState === 4) {
                this.handleGetResponse(httpRequest);
            }
        };
        httpRequest.open('GET', `${this.APIANSWERURL}?param=${this.competitionId}`, true);
        httpRequest.send();
    }

    handleAjaxCall(e) {
        e.preventDefault();
        this.ctaButton.classList.add('is--submitting');
        this.ctaButton.disabled = true;
        const httpRequest = new XMLHttpRequest();

        // Save answer
        if (this.selectAnswer.id == undefined)
            this.setLocalStorage(this.selectAnswer);
        else
            this.setLocalStorage(this.selectAnswer.id);

        // Make request
        httpRequest.onreadystatechange = () => {
            if (httpRequest.readyState === 4) {
                this.handleResponse(httpRequest);
            }
        };

        if (this.selectAnswer.value == undefined) {
            httpRequest.open('POST', `${this.APIURL}?param=${this.selectAnswer}`, true);
        }
        else {
            httpRequest.open('POST', `${this.APIURL}?param=${this.selectAnswer.value}`, true);
        }

        httpRequest.send();
    }

    handleResponse(apiResponse) {
        // If response is not valid else continue
        if (apiResponse.status === 0 && apiResponse.responseText.length === 0) {
            const targetEl = this.errorContainter.getElementsByTagName('p')[0];
            const errorObj = {
                message: this.scConfig.cannotComplete,
                targetDiv: targetEl
            };
            this.renderResult(errorObj);
        } else {
            const { status, responseText } = apiResponse;
            const responseObject = {
                code: status,
                message: JSON.parse(responseText),
                targetDiv: ''
            };
            //debugger;
            if (status === 418) {
                //**** redirect to login
                window.location.href = `${this.signUpRedirect.value}?returnUrl=${location.href}`;
            }
            else if (status === 200) {
                //debugger;
                //const targetEl = this.successContainter.getElementsByTagName('p')[0];
                //responseObject.targetDiv = targetEl;
                //this.renderResult(responseObject, true);
                this.getPollsResult();
            } else if (status === 409) {
                const targetEl = this.errorContainter.getElementsByTagName('p')[0];
                responseObject.targetDiv = targetEl;
                this.renderResult(responseObject);
            } else {
                const targetEl = this.errorContainter.getElementsByTagName('p')[0];
                responseObject.targetDiv = targetEl;
                this.renderResult(responseObject);
            }
        }
    }

    handleGetResponse(apiResponse) {
        const { status, responseText } = apiResponse;
        const responseObject = {
            code: status,
            message: JSON.parse(responseText),
            targetDiv: ''
        };
        if (status === 200) {
            //debugger;
            const targetEl = this.pollResultAnswers;
            responseObject.targetDiv = targetEl;
            if (!responseObject.message.AlreadyAnswered) {
                responseObject.message = "";
            }
            this.renderResult(responseObject, true);
        }
        else {
            const targetEl = this.pollResultErrorContainter.getElementsByTagName('p')[0];
            responseObject.targetDiv = targetEl;
            this.renderResult(responseObject);
        }
    }

    renderResult(obj, isSuccess) {
        //debugger;
        let resultClass = '';

        if (isSuccess) {
            resultClass = 'is--success';
            // remove stored answer - no longer required to be saved
            this.removeLocalStorage();
        } else {
            resultClass = 'is--error';
        }
        const { message, targetDiv } = obj;
        if (message.AlreadyAnswered) {
            this.root.querySelector('form').style.display = 'none';
            this.pollResultContainer.style.display = 'block';
            let template = '';
            for (var i = 0; i < message.Answers.length; i++) {
                template = template + `<div class='competition-form__question-row polling-btn'><p class='venu-details'>${message.Answers[i].Answer} - ${message.Answers[i].AnswerPercent}%</p></div>`;
            }
            targetDiv.innerHTML = template;
        }
        else {
            this.pollResultContainer.style.display = 'none';
            this.root.querySelector('form').style.display = 'block';
            targetDiv.innerHTML = `${message}`;
        }
        this.root.classList.add(resultClass);
        this.ctaButton.classList.remove('is--submitting');
        if (message == "") {
            this.resetForm();
        }
        else
            this.ctaButton.disabled = false;
    }

    getLocalStorage() {
        const selectedOption = localStorage.getItem('fa-comp-answer');

        if (selectedOption) {
            var selectedAnswer = document.getElementById('competition-form__search-input');
            if (selectedAnswer) {
                selectedAnswer.setAttribute('data-value', selectedOption);
            }
            else {
                const option = this.root.querySelector(`#${selectedOption}`);
                if (option) {
                    option.checked = true;
                }
            }
        }
    }

    setLocalStorage(answer) {
        localStorage.setItem('fa-comp-answer', answer);
    }

    removeLocalStorage() {
        localStorage.removeItem('fa-comp-answer');
    }
}

export default EnglandSupportersPolls;



// WEBPACK FOOTER //
// ./components/esc-redesign/scripts/esc-polls.js